/**
 * @packageDocumentation
 * @module f1/boolean
 */

/**
 * @param v value to evaluate
 */
export type LtValue<V> = (v: V) => boolean;

export interface Lt {
  /**
   * Same as `x(v) < y(v)`.
   *
   * @public
   * @function f1.lt
   * @param x the first conditional function
   * @param y the first conditional function
   * @param v value to evaluate
   * @example
   *
   * ```ts
   * lt(() => 1, () => 2, '') === true
   * lt(() => 2, () => 2, '') === false
   * ```
   */
  <V>(x: (v: V) => boolean, y: (v: V) => boolean, v: V): boolean;
  /**
   * {@link FnLtValue}
   * @param x the first conditional function
   * @param y the first conditional function
   */
  <V>(x: (v: V) => boolean, y: (v: V) => boolean): LtValue<V>;
}

/**
 * @see Lt
 */
export default <V>(x: (v: V) => boolean, y: (v: V) => boolean, v: V): boolean => x(v) < y(v);
